import { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { Checkout } from '@/features/jobs/drafting/checkout/components/Checkout'
import { type CheckoutViewModel } from '@/features/jobs/drafting/checkout/CheckoutViewModel'
import { ApplyCouponAsAdminDialogContainer } from '@/features/jobs/ApplyCouponAsAdminDialog/ApplyCouponAsAdminDialogContainer'
import { RemoveCouponAsAdminDialogContainer } from '@/features/jobs/RemoveCouponAsAdminDialog/RemoveCouponAsAdminDialogContainer'
import { SummaryContainer } from '@/features/jobs/drafting/checkout/components/Checkout/Summary/SummaryContainer'
import { PaymentContainer } from '@/features/jobs/drafting/checkout/components/Checkout/Payment/PaymentContainer'
import { CheckoutSuccess } from '@/features/jobs/drafting/checkout/components/Checkout/Success'
import { useActivation } from '@/hooks/view-model-hooks'

export default observer(function CheckoutContainer() {
  const {
    internal: { checkoutVm: vm },
  } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  return <CheckoutViewContainer vm={vm} />
})

interface CheckoutViewContainerProps {
  vm: CheckoutViewModel
}

const CheckoutViewContainer = observer(function CheckoutViewContainer({
  vm,
}: CheckoutViewContainerProps) {
  useActivation(vm)

  if (vm.checkoutCompleted) {
    return <CheckoutSuccess />
  }

  return (
    <Checkout>
      <SummaryContainer vm={vm} />
      <PaymentContainer vm={vm} />

      {vm.jobCheckoutVms.map(
        (jobVm) =>
          jobVm.canAddCoupons && (
            <Fragment key={jobVm.id}>
              {jobVm.applyCouponAsAdminVm !== null && (
                <ApplyCouponAsAdminDialogContainer
                  vm={jobVm.applyCouponAsAdminVm}
                />
              )}
              {jobVm.removeCouponAsAdminVm !== null && jobVm.hasCoupons && (
                <RemoveCouponAsAdminDialogContainer
                  vm={jobVm.removeCouponAsAdminVm}
                />
              )}
            </Fragment>
          ),
      )}
    </Checkout>
  )
})
